import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import { connect } from "react-redux";
import JwtDecode from "jwt-decode";
import Link from "@material-ui/core/Link";

import ListNav from "../ListNav/ListNav";
import SearchBook from "../SearchBook/SearchBook";
import Info from "./Info";
import { useStyles } from "./MobileDrawer.css";

class MobileDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      firstChar: "",
    };
  }

  componentDidMount() {
    if (this.props.isAuth) {
      this.decodeData(this.props.userToken);
    }
    if (this.props.isAuthor) {
      this.decodeData(this.props.authorToken);
    }
  }

  decodeData = (token) => {
    try {
      let decodedData = JwtDecode(token);
      this.setState({
        data: decodedData,
        firstChar: decodedData.firstName.charAt(0),
      });
    } catch (err) {}
  };

  render() {
    const { classes, container } = this.props;
    return (
      <Drawer
        container={container}
        variant="temporary"
        anchor={classes.theme ? "left" : "right"}
        open={this.props.mobileOpen}
        onClose={this.props.handleToggleDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Toolbar
          position="fixed"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
          }}
        >
          {this.props.isAuthor || this.props.isAuth ? (
            this.props.isAuthor ? (
              <Info
                firstChar={this.state.firstChar}
                email={this.state.data.email}
                type="Author"
              />
            ) : (
              <div>
                <Info
                  firstChar={this.state.firstChar}
                  email={this.state.data.email}
                  type="Customer"
                />
                <SearchBook />
              </div>
            )
          ) : (
            <SearchBook />
          )}
          <Divider style={{ color: "red" }} />

          <ListNav list={this.props.list} />

          {this.props.isAuth || this.props.isAuthor ? (
            <div>Logout</div>
          ) : (
            <div
              style={{
                textAlign: "center",
                fontSize: 18,
              }}
            >
              <div style={{ marginBottom: 10 }}>Login As</div>
              <div style={{ display: "flex" }}>
                <Link
                  href="/login/Customer"
                  className={classes.linkStyle}
                  style={{ marginRight: 5 }}
                >
                  User
                </Link>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ backgroundColor: "#181818", width: 2 }}
                />
                <Link
                  href="/login/Author"
                  className={classes.linkStyle}
                  style={{ marginLeft: 5 }}
                >
                  Author
                </Link>
              </div>
            </div>
          )}
        </Toolbar>
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
    isAuthor: state.AuthorReducer.isAuthor,
    authorToken: state.AuthorReducer.authorToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(MobileDrawer));
